import { render } from "./TardyManagementDetentionAttendance.vue?vue&type=template&id=7dc6950e"
import script from "./TardyManagementDetentionAttendance.vue?vue&type=script&lang=js"
export * from "./TardyManagementDetentionAttendance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__